function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEngineering = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.788,0.688C6.148,0.19 5.24,0.25 4.661,0.822L1.969,3.514C1.397,4.086 1.336,4.995 1.828,5.641L7.212,12.64C7.515,13.037 7.992,13.273 8.49,13.273L12.131,13.273L19.467,20.608C18.478,22.56 18.794,25.01 20.429,26.638L27.967,34.176C28.808,35.017 30.174,35.017 31.015,34.176L35.323,29.868C36.164,29.027 36.164,27.661 35.323,26.82L27.785,19.282C26.156,17.654 23.707,17.331 21.755,18.32L14.419,10.984L14.419,7.35C14.419,6.845 14.184,6.374 13.787,6.072L6.788,0.688ZM2.837,27.008C1.983,27.863 1.498,29.027 1.498,30.239C1.498,32.762 3.544,34.808 6.068,34.808C7.279,34.808 8.443,34.324 9.298,33.469L17.226,25.541C16.701,24.135 16.62,22.607 16.984,21.16L12.831,17.008L2.837,27.008ZM35.955,10.042C35.955,9.336 35.881,8.649 35.74,7.99C35.578,7.236 34.656,7.041 34.111,7.586L29.811,11.886C29.609,12.088 29.333,12.202 29.05,12.202L25.187,12.202C24.595,12.202 24.111,11.718 24.111,11.126L24.111,7.256C24.111,6.973 24.225,6.697 24.427,6.496L28.727,2.195C29.272,1.65 29.077,0.728 28.323,0.566C27.657,0.425 26.971,0.351 26.264,0.351C20.914,0.351 16.573,4.692 16.573,10.042L16.573,10.096L22.314,15.837C24.736,15.224 27.415,15.87 29.313,17.768L30.369,18.825C33.667,17.277 35.955,13.925 35.955,10.042ZM8.497,29.424C8.497,30.319 7.777,31.04 6.882,31.04C5.987,31.04 5.267,30.319 5.267,29.424C5.267,28.529 5.987,27.809 6.882,27.809C7.777,27.809 8.497,28.529 8.497,29.424Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEngineering);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/engineering.89a9c0e70215bef7f9357496fad4ba20.svg";